import { styled } from 'styled-components'

import { mq } from 'styles/mq'

const footerMq = {
  extraSmall: `@media(min-width: ${360 / 16}em)`,
  small: `@media(min-width: ${540 / 16}em)`,
}

export const FooterStyled = styled.div`
  margin: 0 2rem;
  ${mq.large} {
    margin: 0 2.5rem;
  }
  border-top: solid 1px var(--border-color);
`
export const FooterInner = styled.div`
  margin: auto;
  max-width: 524px;
  ${mq.medium} {
    max-width: 732px;
  }
  ${mq.large} {
    max-width: 1140px;
  }
  margin: 3rem auto 6rem;
`
export const Columns = styled.div`
  column-count: 1;
  column-gap: 2rem;
  ${footerMq.extraSmall} {
    column-count: 2;
  }
  ${footerMq.small} {
    column-count: 3;
  }
  ${mq.large} {
    column-gap: 3rem;
    column-count: 5;
  }
  h3 {
    font-weight: normal;
    margin-block: 0.5em;
    font-size: 1.5rem;
    ${mq.medium} {
      font-size: 1.6rem;
    }
  }
`
export const List = styled.dl``
export const Pair = styled.div`
  break-inside: avoid;
  display: inline-block;
  width: 100%;
  margin-block: 0.5em;
`
export const ListTerm = styled.dt`
  display: inline;
  border-bottom: 1px solid var(--text-color);
  font-size: 1.3rem;
  ${mq.medium} {
    font-size: 1.4rem;
  }
`
export const ListDescription = styled.dd`
  margin-inline-start: 0;
  font-size: 1.3rem;
  ${mq.medium} {
    font-size: 1.4rem;
  }

  &.comma:nth-child(2) {
    display: block;
    ${footerMq.extraSmall} {
      display: none;
    }
  }
  &.comma:nth-child(3) {
    display: none;
    ${footerMq.extraSmall} {
      display: block;
    }
  }
`
